const carpenterDetailedRateCard = {
  key: "carpenter",
  title: "Carpenter Detailed Rate Card",
  note:
    "Indicative carpentry pricing. Final price can depend on wood condition, hardware type, material replacement, polish/finish requirements, and fitting complexity.",
  sections: [
    {
      title: "Doors & Locks",
      items: [
        { name: "Door alignment", price: "₹249 per door" },
        { name: "Lock installation / replacement", price: "₹249 per lock" },
        { name: "Hinge replacement", price: "₹149 per hinge set" },
        { name: "Tower bolt / latch fitting", price: "₹149 per unit" },
      ],
    },
    {
      title: "Furniture",
      items: [
        { name: "Furniture minor repair", price: "₹299 onwards" },
        { name: "Drawer channel adjustment", price: "₹199 per drawer" },
        { name: "Cabinet shutter alignment", price: "₹199 per shutter" },
        { name: "Handle fitting", price: "₹99 per handle" },
      ],
    },
    {
      title: "Shelves & Accessories",
      items: [
        { name: "Wall shelf installation", price: "₹299 onwards" },
        { name: "Curtain rod installation", price: "₹199 per rod" },
        { name: "Mirror / accessory mount support", price: "₹149 onwards" },
      ],
    },
    {
      title: "Inspection",
      items: [
        { name: "Woodwork inspection", price: "₹249 visit" },
      ],
    },
  ],
};

export default carpenterDetailedRateCard;